import {BASE_PATH_API, TIMEOUT_TIME} from '../constants/general'
import { decodeStorage } from '../functions/storageBase64'
import axios from '../../node_modules/axios'


//- Get Cart
export async function getCart () {
    const codigoPostal  = decodeStorage('codigoPostal')
    const byCart = decodeStorage('idCarrito')

    if (!byCart || byCart === 'undefined') {
        return {
            'headers': '',
            'statusCode': 400,
            'data': null,
            'error': 'No cart id'
        };
    }

    const apiURL = `${BASE_PATH_API}/app/v1/cart/${byCart}`

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}


//- Get Count Card
export async function getCartCount () {
    const byCart = decodeStorage('idCarrito')
    
    if (!byCart || byCart === 'undefined') {
        return {
            'headers': '',
            'statusCode': 400,
            'data': null,
            'error': 'No cart id'
        };
    }

    const apiURL = `${BASE_PATH_API}/app/v1/cart-counter/${byCart}`

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME
    }

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response
        }
    })
}